export const SystemNotFoundTroubleshooting = () =>
    <div className="font-normal text-sm p-3 bg-blue-25 rounded text-gray-700">
        <ul className="mt-4 list-decimal pl-5">
            <li>
                <span className="font-semibold">Navigate</span> to
                the <span className="font-semibold">"Warranty Holder Details - Warranty Tab".</span>
            </li>
            <li>
                <span className="font-semibold">Click</span> on
                the <span className="font-semibold">"Edit Warranty"</span> option to access and modify
                the warranty enrollment details.
            </li>
            <li>
                Carefully verify that the Manufacturer System Identifier entered is correct. This is crucial as
                an incorrect ID can lead to the system not being recognized in the manufacturer's database.
                <div className="pl-4 -indent-2">
                    i. To find the system ID for Enphase systems, log into your Enlighten portal and Navigate
                    to the "Systems" list to find the related system. Click on the system to open its
                    details page. Click on the gear icon to navigate to the Settings tab. The system ID can be
                    found in listed in the Overview card.
                </div>
                <div className="pl-4 -indent-2">
                    ii. To find the site ID for SolarEdge systems, log into your SolarEdge portal and Navigate
                    to the "Sites" list to find the related site. Click on the system to open its
                    details page. The Site ID is listed under the warranty holder name on the Site details card on the
                    right.
                </div>
            </li>
            <li>
                To ensure accuracy, <span className="font-semibold">cross</span>-reference this ID with the site
                listed in the manufacturer's monitoring portal.
            </li>
            <li>
                <span className="font-semibold">Check</span> that the enrollment details include a defined
                inverter manufacturer, and confirm that this value is correct.
            </li>
            <li>
                <span className="font-semibold">Save</span> any changes you make to the warranty details.
            </li>
            <li>
                Click on the <span className="font-semibold">Refresh Monitoring</span> button to initiate a new
                attempt to pull monitoring data.
            </li>
        </ul>
    </div>
